/**
 *
 * These styles are solely for adding [background images] or
 * [background colors] to blocks.
 *
 */

export default {
  headingBetweenBlocks: {
    textAlign: 'center',
    '& > h2': {
      maxWidth: '800px',
    },
  },
  heroContainer: {
    position: `relative`,
    pt: [5, 6],
    '::before, ::after': {
      position: `absolute`,
      content: `" "`,
      width: [`full`, `90%`],
      height: `80%`,
      top: [`-10%`, 0],
      right: `50%`,
      transform: `translate(50%, 0)`,
      zIndex: -1,
    },
    '::before': {
      borderRadius: `xl`,
      background: (t) => `linear-gradient(
          180deg,
          ${t.colors.omegaLighter} 0%,
          ${t.colors.omegaLight} 100%
        )`,
    },
    '::after': {
      backgroundSize: `50%`,
      opacity: 0.1,
    },
  },
  featuresContainer: {
    position: `relative`,
    py: [5, 6],
    '::before': {
      position: `absolute`,
      content: `" "`,
      size: `full`,
      top: 0,
      right: `50%`,
      transform: `translate(50%, 0)`,
      zIndex: -1,
      borderRadius: `xl`,
      background: (t) => `linear-gradient(
          150deg,
          ${t.colors.omegaLighter} 80%,
          ${t.colors.omegaLight} 100%
        )`,
    },
  },
  testimonialsContainer: {
    position: `relative`,
    py: [5, 6],
    '::before, ::after': {
      position: `absolute`,
      content: `" "`,
      width: [`full`, `90%`],
      height: `80%`,
      top: 0,
      right: `50%`,
      transform: `translate(50%, 0)`,
      zIndex: -1,
    },
    '::before': {
      borderRadius: `xl`,
      background: (t) => `linear-gradient(
          150deg,
          ${t.colors.omegaLighter} 50%,
          ${t.colors.omegaLight} 100%
        )`,
    },
    '::after': {
      transform: `scaleX(-1)`,
      // background: `url(${heroBg}) no-repeat left top`,
      backgroundSize: `50%`,
      opacity: 0.1,
    },
  },
  ellipse: {
    position: 'absolute',
    left: 0,
    top: ['400px', '575px', '575px', '575px', '400px'],
    width: '100%',
    height: '420px',
    background: 'linear-gradient(0deg, #F0F9FF 13%, #FFFFFF 100%)',
    clipPath: 'ellipse(100% 100% at top)',
    zIndex: '-10',
    display: ['block', 'none', 'none', 'block', 'block'],
  },
  clients: {
    textAlign: 'center',
  },
  customerHeader: {
    flexDirection: 'column',
  },
  customerInfo: {
    flexDirection: 'column',
    gap: '64px',
  },
  articleContainer: {
    gap: '30px',
    position: 'relative',
  },
  articleMain: {
    flexDirection: 'column',
    flexBasis: [
      'calc(100% - 175px - 30px)',
      '100%',
      '100%',
      '100%',
      'calc(100% - 175px - 30px)',
    ],
    gap: '60px',
    px: ['24px', 0, 0, 0, '24px'],
  },
};
